import React from "react";

const Header = () => {
  return (
    <div className="h-1/3 text-white">
      <img src="../3d-particle-effects.gif" className="absolute height33 w-full" alt="particles"/>
      <div className="absolute w-full h-1/3">
        <div className="h-full flex items-center justify-center">
          <div className="flex w-80 h-24 justify-center flex-col text-center border-2 border-solid border-white">
            <p className="text-4xl font-bold font-serif">Max and Sax</p>
            <p className="small">[ live music ]</p>
            <div className="relative left-1/3 -top-3">
              <p className="transform -rotate-12 italic font-serif font-light">you decide!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default Header;